<template>
  <div>
    <b-card no-body
            :header="category"
            v-for="category in categoriesToShow"
            :key="category"
            border-variant="primary"
            header-bg-variant="primary"
            header-text-variant="white"
            style="margin-bottom: 2em;"
    >
      <template slot="header">
        <h3> {{ category }} </h3>
      </template>

    <b-list-group flush>
    <b-list-group-item v-for="criterion in criteriaFilter(category)" :key="criterion.id"
                        style="text-align: left">
      <div class="d-flex justify-content-space-between align-items-center">
        <div style="min-width: 35%;">
          <h5>{{ criterion.title }}</h5>
          <small>{{ criterion.description }}</small>
        </div>

        <b-input-group style="margin-right: 2em;"
                       v-if="criterion.criteriaContentType === 'GRADE' || criterion.criteriaContentType === 'GRADE_AND_TEXT'"
                       :prepend="criterion.criteriaLowDescription"
                       :append="criterion.criteriaHighDescription" class="mb-1">
          <b-form-rating
              style="min-width: 10em; max-width: 40%"
              icon-empty="circle"
              icon-full="circle-fill"
              variant="info"
              v-model="criterion.evaluation.evaluationValue"
          />
        </b-input-group>
      </div>
      <b-input-group
          v-if="criterion.criteriaContentType === 'TEXT' || criterion.criteriaContentType === 'GRADE_AND_TEXT'"
          prepend="Σχόλια" class="mb-1">
        <b-form-input v-model="criterion.evaluation.comments"></b-form-input>
      </b-input-group>
    </b-list-group-item>

      </b-list-group>
    </b-card>
  <b-button v-if="canSubmit" variant="success" @click="updateValues">Υποβολή</b-button>
  </div>
</template>
<script>
export default {
  name: 'EvaluationCriteriaList',
  props: {
    criteriaList: {},
    categories: {
      type: Array,
    },
    canSubmit: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    categoriesToShow: function() {
      return this.categories?.length > 0? this.categories: [null];
    },
  },
  methods: {
    updateValues(){
      let data = []
      this.criteriaList.forEach(element => data.push({
        criteriaId: element.id,
        evaluationValue: element.evaluation.evaluationValue,
        comments: element.evaluation.comments
      }));
      this.$emit('save', data);

    },
    criteriaFilter(category){
      return category? this.criteriaList.filter(criterion => criterion.category?.title === category): this.criteriaList.filter(criterion => criterion.category===null);
    }
  }
}
</script>